module.exports = __webpack_public_path__ + "img/IMPORT.12669e2f.svg";